import { render, staticRenderFns } from "./QuestionnaireDialog.vue?vue&type=template&id=89088dba&scoped=true"
import script from "./QuestionnaireDialog.vue?vue&type=script&lang=js"
export * from "./QuestionnaireDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireDialog.vue?vue&type=style&index=0&id=89088dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89088dba",
  null
  
)

export default component.exports